import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { Tooltip } from 'primeng/tooltip';
import { ButtonDirective } from 'primeng/button';
import { ClipboardService } from '@brighthub/utils';
import { Message, MessageRole } from '../../models/ask-navi-chat.models';

/**
 * Replicated message bubble for Ask Navi (not exported from `@brighthub/copilot` barrel).
 */
@Component({
  selector: 'an-ask-navi-message',
  standalone: true,
  imports: [CommonModule, MarkdownModule, Tooltip, ButtonDirective],
  templateUrl: './ask-navi-message.component.html',
  styleUrl: './ask-navi-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskNaviMessageComponent {
  private readonly _clipboard = inject(ClipboardService);

  readonly message = input.required<Message>();
  readonly copilotName = input('Navi');
  readonly userDisplayName = input('You');
  readonly userInitials = input('U');
  readonly showThinkingBelow = input(false);

  protected readonly MessageRole = MessageRole;

  copyToClipboard(text: string): void {
    this._clipboard.copy(text);
  }
}
